import React from "react";
import { Link } from "react-router-dom";
import PageLayout from "../components/PageLayout";
import PageHero from "../components/PageHero";

const LearningAndPlacement = () => {
  return (
    <PageLayout>
      <PageHero
        eyebrow="Learning & Placement"
        headline={<>Meeting Each Student <em className="not-italic text-[#c9a961]">Where They Are</em>.</>}
        intro="Angel of Peace Academy is committed to educating each child according to their individual pace rather than their age alone — cultivating mastery in sequential subjects, formation within mixed-age forms, and a nurturing Kindergarten environment for our youngest students."
      />

      {/* Placement & Progression */}
      <section className="bg-[#f6efd8]/40 border-y border-[#eae1c4]">
        <div className="max-w-[1000px] mx-auto px-6 md:px-10 lg:px-14 py-20 md:py-24 text-center">
          <div className="font-sans-nav text-[11.5px] tracking-[0.32em] uppercase text-[#c9a961] mb-4">An Individualized Education</div>
          <h2 className="font-display text-[#1e2952] text-[32px] md:text-[44px]" style={{ fontWeight: 500 }}>Placement &amp; Progression</h2>
          <div className="mt-5 flex items-center justify-center gap-3">
            <span className="block h-px w-40 bg-[#c9a961]"></span>
            <span className="text-[#c9a961]">†</span>
            <span className="block h-px w-40 bg-[#c9a961]"></span>
          </div>
          <div className="mt-10 space-y-6 font-serif-body text-[17px] md:text-[18px] leading-[1.85] text-[#3a466e] text-left">
            <p>Angel of Peace favors depth over volume and mastery over acceleration. In sequential, skill-based subjects — reading, spelling, grammar, arithmetic, and Latin — students are placed according to demonstrated mastery rather than age or grade alone, while continuing to belong to an appropriate Form and school community.</p>
          </div>
        </div>
      </section>

      {/* Kindergarten Community */}
      <section className="bg-[#fbf7ee]">
        <div className="max-w-[900px] mx-auto px-6 md:px-10 lg:px-14 py-20 text-center">
          <div className="font-sans-nav text-[11.5px] tracking-[0.32em] uppercase text-[#c9a961] mb-4">Our Kindergarten Community</div>
          <h2 className="font-display text-[#1e2952] text-[28px] md:text-[36px]" style={{ fontWeight: 500 }}>
            A Gentle Start
          </h2>
          <div className="mt-5 flex items-center justify-center gap-3">
            <span className="block h-px w-40 bg-[#c9a961]"></span>
            <span className="text-[#c9a961]">†</span>
            <span className="block h-px w-40 bg-[#c9a961]"></span>
          </div>
          <p className="font-serif-body mt-8 text-[16.5px] leading-[1.85] text-[#3a466e] text-left">
            Kindergarten at Angel of Peace Academy is a gentle, one- to two-year beginning for children ages 4–6, designed to respect the wide range of development that is normal in the early years. In a warm, play-based environment, children build phonological awareness, beginning reading skills, number sense, and early arithmetic alongside stories, nature, movement, music, and imaginative play. Research in early childhood education supports the value of purposeful play and suggests that some younger children benefit from additional time before entering more formal academics, particularly in areas such as school readiness, early literacy and numeracy, and executive function. Students therefore progress to the Lower School when they demonstrate readiness, in consultation with their parents, rather than according to age alone.
          </p>
          <div className="mt-10 flex justify-center">
            <Link to="/academics" className="btn-navy font-sans-nav text-[12px] tracking-[0.24em] uppercase px-10 py-4">
              Explore Academics
            </Link>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[#1e2952] text-[#fbf7ee]">
        <div className="max-w-[1000px] mx-auto px-6 md:px-10 lg:px-14 py-20 text-center">
          <h2 className="font-display text-[28px] md:text-[38px] leading-tight" style={{ fontWeight: 500 }}>
            Discover Whether Angel of Peace Is Right for Your Family.
          </h2>
          <div className="mt-6 flex items-center justify-center gap-3">
            <span className="block h-px w-40 bg-[#c9a961]"></span>
            <span className="text-[#c9a961]">†</span>
            <span className="block h-px w-40 bg-[#c9a961]"></span>
          </div>
          <div className="mt-10 flex justify-center">
            <Link
              to="/inquire"
              data-testid="learning-placement-cta-inquire"
              className="inline-block font-sans-nav text-[12px] tracking-[0.28em] uppercase px-10 py-4 bg-[#c9a961] text-[#1e2952] hover:bg-[#e2c98a] transition-colors"
            >
              Inquire Today
            </Link>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default LearningAndPlacement;
